<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="unlock">
            <defs>
                <path id="6mgaplo7va" d="M17.146 10.62H6.854c-1.167 0-2.117.95-2.117 2.117v5.146c0 1.167.95 2.117 2.117 2.117h10.292c1.167 0 2.117-.95 2.117-2.117v-5.146c0-1.167-.95-2.117-2.117-2.117zm.824 7.263c0 .455-.37.824-.824.824H6.854c-.455 0-.824-.37-.824-.824v-5.146c0-.454.37-.824.824-.824h10.292c.455 0 .824.37.824.824v5.146zm-1.734-10.42c-.198-.976-.732-1.86-1.502-2.489C13.964 4.346 12.994 4 12 4h-.004c-1.155.001-2.24.452-3.055 1.269-.816.817-1.264 1.903-1.263 3.057v2.94c0 .358.29.647.646.647.357 0 .646-.29.646-.646V8.325c0-.809.314-1.57.886-2.143.571-.573 1.332-.889 2.14-.89H12c1.435 0 2.683 1.02 2.969 2.427.071.35.412.576.762.505.35-.07.576-.412.505-.762z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="9czn0cu1bb" fill="#fff">
                    <use xlink:href="#6mgaplo7va"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#9czn0cu1bb)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-unlock',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>